export function transformSelectedFareToFlight(selectedFare, segmentGroups) {
    return Object.assign(Object.assign({}, selectedFare.flightInfo), { segmentGroups, fares: [] });
}
